var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Web3Provider } from '@ethersproject/providers';
import { useCallback, useEffect, useState } from 'react';
import { usePriorityConnector } from './priorityConnector';
// import { usePriorityConnector, usePriorityProvider } from './connectorHooks';
import { getInjectedAddress } from './injectedData';
import { addToActiveWallets, addToDeactivatedWallets, isWalletDeactivated, removeFromActiveWallets, removeFromDeactivatedWallets, } from './walletPersistance';
export const useLiFiWalletManagement = () => {
    var _a, _b;
    const priorityConnector = usePriorityConnector();
    // "any" because of https://github.com/ethers-io/ethers.js/issues/866
    // const priorityProvider = usePriorityProvider('any');
    // const [currentProvider, setCurrentProvider] = useState<Web3Provider>();
    const [currentConnector, setCurrentConnector] = useState();
    const [signer, setSigner] = useState();
    const flushCurrentWalletData = () => {
        setCurrentConnector(undefined);
        // setCurrentProvider(undefined);
        setSigner(undefined);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const calcWalletData = (connector) => {
        if (connector) {
            const provider = new Web3Provider(connector.provider || window.ethereum, 'any');
            // setCurrentProvider(() => provider);
            setCurrentConnector(() => connector);
            setSigner(() => { var _a; return (_a = provider === null || provider === void 0 ? void 0 : provider.getSigner) === null || _a === void 0 ? void 0 : _a.call(provider); });
        }
    };
    const connect = useCallback((wallet) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (wallet) {
                const { connector } = wallet.web3react;
                yield connector.activate();
                calcWalletData(connector);
            }
            else {
                yield priorityConnector.activate();
            }
        }
        catch (e) {
            console.log(e);
        }
        const selectedAddress = getInjectedAddress(wallet);
        removeFromDeactivatedWallets(selectedAddress);
        addToActiveWallets(selectedAddress);
    }), [calcWalletData, priorityConnector]);
    const disconnect = useCallback((wallet) => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d;
        const selectedAddress = getInjectedAddress(wallet);
        removeFromActiveWallets(selectedAddress);
        addToDeactivatedWallets(selectedAddress);
        if (wallet) {
            yield ((_c = currentConnector === null || currentConnector === void 0 ? void 0 : currentConnector.deactivate) === null || _c === void 0 ? void 0 : _c.call(currentConnector));
            flushCurrentWalletData();
        }
        else if (priorityConnector.deactivate) {
            yield ((_d = priorityConnector.deactivate) === null || _d === void 0 ? void 0 : _d.call(priorityConnector));
            flushCurrentWalletData();
        }
        else {
            yield priorityConnector.resetState();
            flushCurrentWalletData();
        }
    }), [priorityConnector, currentConnector]);
    // eager connect
    useEffect(() => {
        var _a;
        const selectedAddress = getInjectedAddress();
        if (!isWalletDeactivated(selectedAddress) && priorityConnector) {
            (_a = priorityConnector.connectEagerly) === null || _a === void 0 ? void 0 : _a.call(priorityConnector);
            calcWalletData(priorityConnector);
        }
    }, [
        priorityConnector,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        (_a = window.ethereum) === null || _a === void 0 ? void 0 : _a.selectedAddress,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        (_b = window.tally) === null || _b === void 0 ? void 0 : _b.selectedAddress,
    ]);
    // injected wallet listeners
    useEffect(() => {
        const { ethereum } = window;
        const handleChainChanged = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
            yield (currentConnector === null || currentConnector === void 0 ? void 0 : currentConnector.activate());
            calcWalletData(currentConnector);
        });
        const handleAccountsChanged = (accounts) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            if (!accounts.length) {
                yield ((_a = currentConnector === null || currentConnector === void 0 ? void 0 : currentConnector.deactivate) === null || _a === void 0 ? void 0 : _a.call(currentConnector));
                flushCurrentWalletData();
            }
        });
        ethereum === null || ethereum === void 0 ? void 0 : ethereum.on('chainChanged', handleChainChanged);
        ethereum === null || ethereum === void 0 ? void 0 : ethereum.on('accountsChanged', handleAccountsChanged);
        return () => {
            if (ethereum === null || ethereum === void 0 ? void 0 : ethereum.removeListener) {
                ethereum.removeListener('chainChanged', handleChainChanged);
                ethereum.removeListener('accountsChanged', handleAccountsChanged);
            }
        };
    }, [currentConnector]);
    return {
        connect,
        disconnect,
        signer,
        provider: signer === null || signer === void 0 ? void 0 : signer.provider,
    };
};
